import IdCell from './container';

export default IdCell;
